document.addEventListener("DOMContentLoaded", function () {
  const bar = document.getElementById("shukhamStickyBar");
  if (!bar) return;

  const stickyAddToCart = bar.querySelector("[data-add-cart]");

  const stickyVariantInput = bar.querySelector(
    "[data-shukham-sticky-variant]"
  );

  const stickyQuantityInput = bar.querySelector(
    "[data-shukham-sticky-quantity]"
  );

  const mainProductForm =
    document.querySelector(
      'product-form form[action*="/cart/add"]'
    ) ||
    Array.from(
      document.querySelectorAll('form[action*="/cart/add"]')
    ).find(function (form) {
      return form.id !== "product-form-installment";
    });

  const originalAddButton =
    mainProductForm?.querySelector(".product-form__submit") ||
    document.querySelector(".product-form__submit");

  function getMainVariantInput() {
    return (
      mainProductForm?.querySelector('input[name="id"]') ||
      document.querySelector(
        '.product-variant-id:not([data-shukham-sticky-variant])'
      )
    );
  }

  function getMainQuantityInput() {
    return (
      document.querySelector(
        'quantity-input input[name="quantity"]'
      ) ||
      mainProductForm?.querySelector(
        'input[name="quantity"]'
      ) ||
      document.querySelector(
        'input.quantity__input[name="quantity"]'
      )
    );
  }

  function syncVariant() {
    const mainVariantInput = getMainVariantInput();

    if (
      !mainVariantInput ||
      !stickyVariantInput ||
      !mainVariantInput.value
    ) {
      return;
    }

    stickyVariantInput.value = mainVariantInput.value;
    stickyVariantInput.setAttribute(
      "value",
      mainVariantInput.value
    );
  }

  function syncQuantity() {
    const mainQuantityInput = getMainQuantityInput();

    if (!stickyQuantityInput) return;

    let quantity = Number(mainQuantityInput?.value || 1);

    if (!Number.isFinite(quantity) || quantity < 1) {
      quantity = 1;
    }

    stickyQuantityInput.value = String(quantity);
    stickyQuantityInput.setAttribute(
      "value",
      String(quantity)
    );
  }

  function syncProductData() {
    syncVariant();
    syncQuantity();
  }

  stickyAddToCart?.addEventListener("click", function (event) {
    event.preventDefault();

    if (this.disabled) return;

    const mainVariantInput = getMainVariantInput();

    if (mainVariantInput) {
      mainVariantInput.disabled = false;
    }

    if (originalAddButton) {
      originalAddButton.click();
    }
  });

  document.addEventListener("change", function (event) {
    if (
      event.target.matches(
        'input[type="radio"], select, input[name="id"], input[name="quantity"]'
      )
    ) {
      setTimeout(syncProductData, 50);
      setTimeout(syncProductData, 250);
    }
  });

  document.addEventListener("input", function (event) {
    if (event.target.matches('input[name="quantity"]')) {
      syncQuantity();
    }
  });

  document.addEventListener("click", function (event) {
    if (
      event.target.closest(
        'quantity-input button[name="plus"], quantity-input button[name="minus"]'
      )
    ) {
      setTimeout(syncQuantity, 50);
      setTimeout(syncQuantity, 200);
    }
  });

  function syncAvailability() {
    if (!originalAddButton) return;

    const soldOut =
      originalAddButton.disabled ||
      originalAddButton.classList.contains("disabled") ||
      originalAddButton.getAttribute("aria-disabled") === "true";

    if (stickyAddToCart) {
      stickyAddToCart.disabled = soldOut;
      stickyAddToCart.textContent = soldOut
        ? "Sold Out"
        : "Add to Cart";

      stickyAddToCart.style.opacity = soldOut ? "0.5" : "1";
      stickyAddToCart.style.cursor = soldOut
        ? "not-allowed"
        : "pointer";
    }

    const shiprocketContainer = bar.querySelector(
      ".shukham-sticky-buy-now"
    );

    if (shiprocketContainer) {
      shiprocketContainer.style.opacity = soldOut ? "0.5" : "1";
      shiprocketContainer.style.pointerEvents = soldOut
        ? "none"
        : "auto";
    }
  }

  syncProductData();
  syncAvailability();

  const productInfo = document.querySelector("product-info");

  if (productInfo) {
    new MutationObserver(function () {
      syncProductData();
      syncAvailability();
    }).observe(productInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        "value",
        "disabled",
        "class",
        "aria-disabled"
      ]
    });
  }

  let checks = 0;

  const timer = setInterval(function () {
    syncProductData();
    syncAvailability();

    checks++;

    if (checks >= 20) {
      clearInterval(timer);
    }
  }, 250);
});